import { GreaterThanOrEqual, LessThan } from '../Media'
import { DropdownContentControlled } from './DropdownContent'

type NavDropdownContentProps = {
  show: boolean
  setShow(s: boolean): void
  children: React.ReactNode
  renderKey?: string
}

export const NavDropdownContent = ({
  show,
  setShow,
  children,
  renderKey = 'content',
}: NavDropdownContentProps) => {
  const breakpoint = 'lg'
  if (!show) return null
  return (
    <>
      <LessThan
        bp={breakpoint}
        className='d-flex flex-column mc-overflow--hidden mc-h-100'
      >
        {children}
      </LessThan>
      <GreaterThanOrEqual bp={breakpoint}>
        <DropdownContentControlled
          key={`nav-dropdown-${renderKey}`}
          show={show}
          setShow={setShow}
        >
          {children}
        </DropdownContentControlled>
      </GreaterThanOrEqual>
    </>
  )
}
